const PATH_ALIASES = {
    selections: '/manage/selections',
    players: '/players',
    communicate: '/communicate',
    settings: '/settings',
    'manage/selections': '/manage/selections',
    'manage/selections/team-view': '/manage/selections/team-view',
    'squads-teams': '/settings/squads-teams',
    branding: '/settings/branding',
    'manage-access': '/settings/manage-access',
};

const MARKDOWN_PATTERN = /(\*\*(.+?)\*\*|\[([^\]]+)\]\(([^)]+)\))/g;

export function normalizeAssistantUrl(url) {
    if (!url || typeof url !== 'string') {
        return url;
    }

    let normalized = url.trim();

    if (normalized.startsWith('http://') || normalized.startsWith('https://')) {
        try {
            const parsed = new URL(normalized);

            return parsed.pathname + parsed.search;
        } catch {
            return normalized;
        }
    }

    if (normalized.startsWith('#/')) {
        normalized = normalized.slice(2);
    } else if (normalized.startsWith('#')) {
        normalized = normalized.slice(1);
    }

    normalized = normalized.replace(/^\/+/, '');

    if (PATH_ALIASES[normalized]) {
        return PATH_ALIASES[normalized];
    }

    if (normalized.startsWith('settings/')) {
        return `/${normalized}`;
    }

    if (normalized.startsWith('manage/')) {
        return `/${normalized}`;
    }

    return normalized.startsWith('/') ? normalized : `/${normalized}`;
}

/**
 * @param {string} text
 * @param {number} depth
 * @returns {Array<{type: 'text', value: string}|{type: 'bold', children: Array}|{type: 'link', href: string, children: Array}>}
 */
export function parseInlineMarkdown(text, depth = 0) {
    if (!text || typeof text !== 'string') {
        return [];
    }

    if (depth > 8) {
        return [{ type: 'text', value: text }];
    }

    const nodes = [];
    let lastIndex = 0;
    const pattern = new RegExp(MARKDOWN_PATTERN.source, 'g');
    let match;

    while ((match = pattern.exec(text)) !== null) {
        if (match.index > lastIndex) {
            nodes.push({ type: 'text', value: text.slice(lastIndex, match.index) });
        }

        if (match[2] !== undefined) {
            nodes.push({
                type: 'bold',
                children: parseInlineMarkdown(match[2], depth + 1),
            });
        } else if (match[3] && match[4]) {
            nodes.push({
                type: 'link',
                href: normalizeAssistantUrl(match[4]),
                children: parseInlineMarkdown(match[3], depth + 1),
            });
        }

        lastIndex = pattern.lastIndex;
    }

    if (lastIndex < text.length) {
        nodes.push({ type: 'text', value: text.slice(lastIndex) });
    }

    return nodes.length > 0 ? nodes : [{ type: 'text', value: text }];
}

export function parseNavigationLinks(content) {
    if (!content || typeof content !== 'string') {
        return [];
    }

    const linkPattern = /\[([^\]]+)\]\(([^)]+)\)/g;
    const links = [];
    let match;

    while ((match = linkPattern.exec(content)) !== null) {
        links.push({
            label: match[1].replace(/\*\*/g, '').trim(),
            url: normalizeAssistantUrl(match[2]),
        });
    }

    return links;
}
